import type { PythonExecutorOutput } from './types.ts';

/**
 * Safely parses the stdout returned by the Python code executor subprocess.
 * 
 * @param rawOutput The raw stdout from the execution of the Python layout runner.
 * @returns The parsed layout coordinates and rotations.
 */
export function parsePythonOutput(rawOutput: string): PythonExecutorOutput {
  try {
    const data = JSON.parse(rawOutput.trim());
    
    if (data && typeof data === 'object' && data.status === 'success') {
      const items = data.items || [];
      const placements = items.map((item: any) => ({
        id: item.itemId,
        position: item.position,
        rotation: item.angle
      }));
      return {
        status: 'success',
        placements,
        items,
        warnings: data.warnings || []
      };
    }
    
    // Backward compatibility check for placements-only response
    if (data && typeof data === 'object' && 'placements' in data) {
      return {
        status: 'success',
        placements: data.placements
      };
    }
    
    return {
      status: 'error',
      error: data.error || 'Python output did not contain valid placement coordinate structure.',
      placements: [],
    };
  } catch (error) {
    return {
      status: 'error',
      error: `Failed to parse Python stdout as JSON: ${error instanceof Error ? error.message : String(error)}`,
      placements: [],
    };
  }
}
